<template>
  <div id="footer">
    <div class="footer-container">
      <div class="text-container">
        <div class="f-text">
          CHANGE IS IN THE AIR®
        </div>
        <div class="f-text">
          SmartAC.com
        </div>
        <div class="f-text">
          Copyright {{ year }}
        </div>
      </div>
    <!-- <div class="text-container">
      <div class="f-text">
        Release notes
      </div>
      <div class="f-text">
        Version {{releaseVersion}}
      </div>
    </div> -->
    </div>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  name: 'Footer',
  data() {
    return {
      year: moment().year(),
    };
  },
};
</script>

<style lang="scss">

#footer {
  position: fixed;
  bottom: 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: $BLACK;
  height: 28px;
  padding: 0 100px;
  z-index: 10;
  @media (max-width: 1279px) {
    padding: 0 60px;
  }
  @media (max-width: 1023px) {
    padding: 0 40px;
  }
  .footer-container {
    display: flex;
    max-width: 1705px;
    width: 100%;
    align-items: center;
    justify-content: space-between;
    .text-container {
      display: flex;
      align-items: center;
      .f-text {
        font-size: 0.75rem;
        color: $N60;
        font-weight: 500;
        &:not(:last-child) {
          margin-right: 14px;
        }
      }
    }
    .registered-tagline {
      font-size: 0.75rem;
      color: $WHITE;
      font-weight: 700;
    }
  }
}
</style>
